export const MESSAGES_PATH = '/messages';
export const MESSAGES_TAB_QUEUE_PATH = MESSAGES_PATH + '/queue';
export const MESSAGES_TAB_ONGOING_PATH = MESSAGES_PATH + '/ongoing';
export const MESSAGES_TAB_SUPPORTED_PATH = MESSAGES_PATH + '/supported';
